import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";
import moment from "moment";

const SignUp = ({ dispatch_post_authin_code }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();
  const [t, i18n] = useTranslation();
  useEffect(() => {}, []);

  const [code, set_code] = useState("");

  return (
    <>
      <div class="bg-light">
        <form
          action="verify.html"
          method="post"
          className="d-flex flex-column justify-content-between vh-100"
        >
          <header className="py-3 mb-auto bg-brand">
            <div className="container d-flex justify-content-between align-items-center">
              <a
                className="text-white"
                href="javascript:history.back();"
                onClick={(e) => {
                  e.preventDefault();
                  history.goBack();
                  window.scroll(0, 0);
                }}
              >
                <i className="fas fa-angle-left fa-fw" />
                {t("戻る")}
              </a>
              <a
                href="index.html"
                onClick={(e) => {
                  e.preventDefault();
                  history.goBack();
                  window.scroll(0, 0);
                }}
              >
                <img src="images/brand-white.svg" height={28} alt="SC WORLD EXCHANGE" />
              </a>
            </div>
          </header>
          <main role="main" className="main">
            <div className="container">
              <section className="login-section mx-auto mb-4">
                <div className="card">
                  <div className="card-body">
                    <form action="account/index.html" method="post">
                      <h1 className="h4 text-center font-weight-bold">
                        {t("コード認証")}
                      </h1>
                      <span className="d-block text-center mb-4">
                        {t("SC WORLD EXCHANGE アカウント")}
                      </span>
                      <div className="form-group">
                        <label htmlFor="ml">{t("入力されたメールアドレス宛に届いた認証コードを入力してください。")}</label>
                        <input
                          type="email"
                          id="ml"
                          className="form-control"
                          placeholder="123456"
                          required
                          // autofocus
                          value={code}
                          onChange={(e) => {
                            set_code(e.target.value);
                          }}
                        />
                      </div>

                      <div className="form-group mb-0">
                        <button
                          type="button"
                          className="btn btn-gradient-primary btn-block"
                          onClick={(e) => {
                            e.preventDefault();
                            dispatch_post_authin_code(
                              {
                                code,
                              },
                              () => {
                                history.push({
                                  pathname: `/exch-market`,
                                  nonce: moment().unix(),
                                });
                                window.scroll(0, 0);
                                window.jQuery(".navbar-toggler").click();
                              }
                            );
                          }}
                        >
                          {t("送信")}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </section>
            </div>
          </main>
          <footer className="mt-auto" />
        </form>
      </div>
    </>
  );
};

export default SignUp;
